module.exports = __webpack_public_path__ + "static/img/lunbo1.b44eb597.webp";